import { render } from "./GetInTouch.vue?vue&type=template&id=60c8931e&scoped=true&ts=true"
import script from "./GetInTouch.vue?vue&type=script&lang=ts"
export * from "./GetInTouch.vue?vue&type=script&lang=ts"

import "@/components/GetInTouch/style.scss?vue&type=style&index=0&id=60c8931e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c8931e"]])

export default __exports__